export const PriceListMockup = () => (
    <svg width="320" height="280" viewBox="0 0 320 280" fill="none">
        {/* Main document */}
        <rect x="60" y="30" width="200" height="220" rx="6" fill="white" className="drop-shadow-lg" />
        {/* Header */}
        <rect x="80" y="50" width="100" height="10" rx="2" fill="#d1d5db" />
        <rect x="80" y="68" width="60" height="6" rx="1" fill="#e5e7eb" />
        {/* List items */}
        <rect x="80" y="95" width="160" height="24" rx="3" fill="#f3f4f6" />
        <rect x="90" y="102" width="80" height="6" rx="1" fill="#9ca3af" />
        <rect x="200" y="102" width="30" height="6" rx="1" fill="#d1d5db" />

        <rect x="80" y="127" width="160" height="24" rx="3" fill="#8db599" fillOpacity="0.15" />
        <rect x="90" y="134" width="70" height="6" rx="1" fill="#8db599" />
        <rect x="200" y="134" width="30" height="6" rx="1" fill="#8db599" />

        <rect x="80" y="159" width="160" height="24" rx="3" fill="#f3f4f6" />
        <rect x="90" y="166" width="90" height="6" rx="1" fill="#9ca3af" />
        <rect x="200" y="166" width="30" height="6" rx="1" fill="#d1d5db" />

        <rect x="80" y="191" width="160" height="24" rx="3" fill="#f3f4f6" />
        <rect x="90" y="198" width="60" height="6" rx="1" fill="#9ca3af" />
        <rect x="200" y="198" width="30" height="6" rx="1" fill="#d1d5db" />
        {/* Star accent */}
        <path d="M270 60 L275 75 L290 75 L278 85 L283 100 L270 90 L257 100 L262 85 L250 75 L265 75 Z" fill="#8db599" />
    </svg>
);